import * as types from '../constants/actionTypes';
import { Action } from '../utils/apiUtil';

export function changeAppRoot(root, message = '') {
  return { type: types.ROOT_CHANGED, root, message };
}

export function appInitialized() {
  return dispatch => {
    dispatch(changeAppRoot(types.PIN));
  };
}

export function reset() {
  return dispatch => {
    dispatch(Action(types.RESET, null));
  };
}
